import { Select } from "melco-ui";
import { useGetCategories } from "../../hooks/categories/useGetCategories";
import { useTranslation } from "react-i18next";

type CategoriesSelectProps = {

    onChange?: (value: string | string[]) => void;
    value?: string | string[];
    disabled?: boolean;
    mode?: string;
}

export const CategoriesSelect: React.FC<CategoriesSelectProps> = (
    {

        onChange,
        value,
        mode,
        disabled
    }
) => {
    const { data } = useGetCategories();
    const { t } = useTranslation()
    let options = data?.map((c) => ({

        value: c.id,
        label: c.name
    })
    )

    // console.log(options)

    return (<>
        <Select
            mode={mode === "multiple" ? "multiple" : undefined}
            value={value}
            onChange={onChange}
            disabled={disabled}
            placeholder={t('common.categories')}
            allowClear
            maxTagCount={1}
            options={options}
            style={{ width: "100%", minWidth: "150px" }}
        />
    </>)
}